import React, { useEffect, useMemo, useState } from "react";
import Footer from "../components/Footer";
import Category from "../components/Home/Category";
import banner from "../assets/banner.png";
import Banner from "../components/Home/Banner";
import Collections from "../components/Home/Collections";
import ProductSlide from "../components/Home/ProductSlide";
import Essence from "../components/Home/Essence";
import Brands from "../components/Home/Brands";
import Testinomial from "../components/Home/Testinomial";
import ContactForm from "../components/Home/ContactForm";
import Subscribe from "../components/Home/Subscribe";
import Faqs from "../components/Home/Faqs";
import { useDispatch } from "react-redux";
import Explore from "../components/Home/Explore";
import { fetchProducts } from "../redux/api/products";
import NewsTicker from "../components/Home/Newtricker";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar";
import Hero from "../components/Home/Hero";
import api from "../utilis/api";
const Home = () => {
  const [data, setData] = useState([]);
  const [content, setContent] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchProducts())
      .unwrap()
      .then((data) => {
        setData(data);
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
      });
  }, [dispatch]);
  console.log(data);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const womenTag = "Women";
  const menTag = "Men";

  const womenProducts = useMemo(() => {
    if (!data.data) return [];
    return data.data.filter((product) =>
      product.tags?.some((tag) => tag.toLowerCase() === womenTag.toLowerCase()),
    );
  }, [data.data]);

  const menProducts = useMemo(() => {
    if (!data.data) return [];
    return data.data.filter((product) =>
      product.tags?.some((tag) => tag.toLowerCase() === menTag.toLowerCase()),
    );
  }, [data.data]);

  const API = "/content/all";

  // Fetch testimonials safely
  const fetchContent = async () => {
    try {
      const res = await api.get(API);
      // Ensure we always have an array

      setContent(Array.isArray(res.data.data) ? res.data.data : []);
    } catch (err) {
      console.error("Failed to fetch testimonials:", err);
      setContent([]);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);
  const menCollections = content.filter((item) => item.section === "men");
  const womenCollections = content.filter((item) => item.section === "women");
  const testimonial = content.filter((item) => item.section === "Testimonial");

  const essenceCollections = content.filter(
    (item) => item.section === "Essence",
  );
  const brands = content.filter((item) => item.section === "brands");
  const womenProduct = content.filter(
    (item) => item.section === "women products",
  );
  const menProduct = content.filter(
    (item) => item.section === "Featured Men Collections",
  );

  return (
    <>
      <Helmet>
        <title>Home - Aruh Fragrances</title>
        <meta name="description" content="Welcome to Home page" />
      </Helmet>
      {/* <div className="bg-black"> */}
      <Navbar />
      {/* </div> */}
      <Hero />
      {/* <Topbar /> */}
      {/* <Banner
        height={"100vh"}
        img={banner}
        Title="Aruhi"
        secttile="Fragrances"
        dec1="Awaken Your Senses with Every Spritz"
        dec2="Dive into a world of timeless elegance and fresh sophistication. Discover our signature scents crafted to leave a lasting impression."
      /> */}
      <Category />
      <Collections
        cate={"men"}
        title={menCollections[0]?.title}
        data={menProducts}
        tagline={menCollections[0]?.detail}
        category={"men"}
      />
      <NewsTicker />
      <Essence data={essenceCollections[0]} />
      <Brands data={brands[0]} />
      <ProductSlide
        title={menProduct[0]?.title}
        data={menProducts}
        tagline={menProduct[0]?.detail}
      />
      <ProductSlide
        title={womenProduct[0]?.title}
        data={womenProducts}
        tagline={womenProduct[0]?.detail}
      />
      <Explore />
      <Collections
        cate={"women"}
        title={womenCollections[0]?.title}
        data={womenProducts}
        tagline={womenCollections[0]?.detail}
        category={"women"}
      />
      <Testinomial data={testimonial[0]} />
      <ContactForm />
      <Subscribe />
      <Faqs /> {/* */}
      <Footer />
    </>
  );
};

export default Home;
